/**
 * 商品数据文件
 * 包含所有水晶产品的详细信息，用于在网站上展示
 * 每个产品对象包含以下属性：
 * - id: 唯一标识符
 * - name: 产品名称
 * - price: 价格（人民币）
 * - imageUrl: 主图片URL
 * - crystalType: 水晶类型名称
 * - crystalTypeId: 水晶类型ID（用于分类和筛选）
 * - categoryId: 产品类别ID（1:项链, 2:手链, 3:耳环, 4:戒指, 5:吊坠, 6:原石, 7:套装）
 * - popularity: 人气指数（用于排序和推荐）
 * - description: 产品描述
 * - energyDescription: 能量描述（水晶的能量特性和效果）
 * - scienceExplanation: 科学解释（水晶的科学特性和组成）
 * - material: 材质信息
 * - size: 尺寸信息
 * - weight: 重量信息
 * - suitableFor: 适用场景
 * - wearingAdvice/placementAdvice/usageAdvice: 佩戴/摆放/使用建议
 * - careInstructions: 保养说明
 * - origin: 原产地
 * - certification: 认证信息
 * - images: 产品图片数组（包含多角度展示图）
 * - 其他可选属性: 根据不同产品类型可能有特定属性
 */
const products = [
  /**
   * 紫水晶系列产品 - 项链
   * 紫水晶代表智慧与灵性，能帮助集中注意力，增强直觉力，平衡情绪
   */
  {
    id: 1,
    name: '紫水晶项链',
    price: 299,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/amethyst_necklace_on_white_background_a15c3287.webp',
    crystalType: '紫水晶',
    crystalTypeId: 1,
    categoryId: 1, // 项链
    popularity: 128,
    description: '精选天然紫水晶，手工打磨抛光，925银扣头，能量纯净',
    energyDescription: '紫水晶代表智慧与灵性，能帮助集中注意力，增强直觉力，平衡情绪',
    scienceExplanation: '紫水晶的主要成分是二氧化硅，其紫色来源于铁离子杂质。科学研究表明，水晶的压电效应能产生微电流，可能对人体生物电场产生影响。',
    material: '925纯银、天然紫水晶（6-8mm）',
    size: '链长45cm，可调节至40cm',
    weight: '约8.5g',
    suitableFor: '日常佩戴、冥想、灵性工作、提升专注力',
    wearingAdvice: '紫水晶项链最好贴近心轮佩戴，能更好地平衡情绪。建议在满月时净化水晶能量。',
    careInstructions: '避免接触化学品和香水，不建议长时间浸泡在水中。可用柔软的布轻轻擦拭表面。',
    origin: '巴西',
    certification: '附赠水晶能量证书',
    images: [
      process.env.PUBLIC_URL + '/assets/images/products/amethyst_necklace_on_white_background_a15c3287.webp',
      process.env.PUBLIC_URL + '/assets/images/products/beautiful_amethyst_necklace_on_white_background_f040f165.webp',
      process.env.PUBLIC_URL + '/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp'
    ]
  },
  /**
   * 混合水晶系列产品 - 手链
   * 多种水晶组合，提供全面的能量平衡和多方面的能量补给
   */
  {
    id: 15,
    name: "多金水晶手链",
    price: 1268,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/3cf62efabf8afdaf9e278da5ca693dfc.jpg',
    crystalType: "混合水晶",
    crystalTypeId: 6,
    categoryId: 2, // 手链
    popularity: 999,
    description: "【多金】精选强磁场水晶，高频吸财幽灵貔貅和黑发晶貔貅，绿幽灵和金发晶的财运层层拔高之气，铜顺发和红兔毛顺财旺财，星辉骨干和黑发晶对财富的强稳之力，白幽灵的干净磁场，让你的财运畅通无阻，多财多金，尺寸10.5mm，配色饱满，晶体通透，佩戴大气。",
    energyDescription: "汇聚强磁场水晶能量，提升财运吸财能力，稳固财富运势，促进财运畅通无阻，实现多财多金。",
    scienceExplanation: "多种强磁场天然水晶组合，包含幽灵貔貅、黑发晶貔貅、绿幽灵、金发晶、铜顺发、红兔毛、星辉骨干、白幽灵等，硬度在6-7之间。",
    material: '天然水晶（幽灵貔貅、黑发晶貔貅、绿幽灵、金发晶、铜顺发、红兔毛、星辉骨干、黑发晶、白幽灵等）',
    size: '10.5mm珠子，适合多种手腕尺寸',
    weight: '约25g',
    suitableFor: '日常佩戴、招财纳福、财富提升',
    wearingAdvice: '建议佩戴在左手以接收水晶能量，右手则适合释放负面能量。',
    careInstructions: '避免接触化学物质，定期用清水冲洗并在月光下净化。',
    origin: '多国原产（巴西、乌拉圭、印度等）',
    images: [
      process.env.PUBLIC_URL + '/assets/images/products/3cf62efabf8afdaf9e278da5ca693dfc.jpg'
    ]
  },
  {
    id: 14,
    name: "三色水晶手链",
    price: 328,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/8af2d18a2323a03cfa60df7d446c06dd.jpg',
    crystalType: "混合水晶",
    crystalTypeId: 6,
    categoryId: 2, // 手链
    popularity: 998,
    description: "三色水晶的色彩融合，贵人相助的胶花，智慧的紫水晶，财富的黄塔晶，流动绚丽的色彩，如同韶光流转，照亮你的前途与事业。偷偷加入招财纳福的紫晶貔貅，黑金超，红胶花，让你的财运更加坦途无阻，尺寸9mm，品质优秀，佩上手精致大方。",
    energyDescription: "汇聚贵人相助、招财纳福能量，提升智慧与财富运，照亮事业前途，促进财运坦途无阻。",
    scienceExplanation: "多种天然水晶组合，包含紫水晶、黄塔晶、红胶花、紫晶貔貅、黑金超等，硬度在6-7之间。",
    material: '天然水晶（紫水晶、黄塔晶、红胶花、紫晶貔貅、黑金超等）',
    size: '9mm珠子，适合多种手腕尺寸',
    weight: '约20g',
    suitableFor: '日常佩戴、招财纳福、事业提升',
    wearingAdvice: '建议佩戴在左手以接收水晶能量，右手则适合释放负面能量。',
    careInstructions: '避免接触化学物质，定期用清水冲洗并在月光下净化。',
    origin: '多国原产（巴西、乌拉圭、印度等）',
    images: [
      process.env.PUBLIC_URL + '/assets/images/products/8af2d18a2323a03cfa60df7d446c06dd.jpg'
    ]
  },
  {
    id: 13,
    name: "五行多宝水晶手链",
    price: 468,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/570b3fba3b1c47d6e1ae480ebe25ba4d.jpg',
    crystalType: "混合水晶",
    crystalTypeId: 6,
    categoryId: 2, // 手链
    popularity: 997,
    description: "天然水晶五行多宝手链，包含海蓝宝、绿发晶、紫水晶等多种水晶，尺寸9mm，晶体干净，色泽饱满，上手精致大方。",
    energyDescription: "综合多种水晶能量，平衡五行，促进全方位能量补给，宁静身心，提升活力。",
    scienceExplanation: "多种天然水晶组合，每种水晶具有独特的矿物成分和晶体结构，硬度在6-7之间。",
    material: '天然水晶（海蓝宝、绿发晶、紫水晶、红胶花、青金石等）',
    size: '9mm珠子，弹力绳设计适合多种手腕尺寸',
    weight: '约20g',
    suitableFor: '日常佩戴、能量平衡、五行调和',
    wearingAdvice: '建议佩戴在左手以接收水晶能量，右手则适合释放负面能量。',
    careInstructions: '避免接触化学物质，定期用清水冲洗并在月光下净化。',
    origin: '多国原产（巴西、乌拉圭、印度等）',
    images: [
      process.env.PUBLIC_URL + '/assets/images/products/570b3fba3b1c47d6e1ae480ebe25ba4d.jpg',
      process.env.PUBLIC_URL + '/assets/images/products/0c06a57504675474e32f5ef797cf6eff.jpg',
      process.env.PUBLIC_URL + '/assets/images/products/微信视频2025-07-29_001114_097.mp4',
    ]
  },
  /**
   * 粉晶系列产品 - 手链
   * 粉晶代表爱与和谐，能促进自爱和人际关系，平衡情绪，吸引爱情
   */
  {
    id: 2,
    name: "粉晶爱心手链",
    price: 199,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/rose_quartz_bracelet_on_white_background_82760464.webp",
    crystalType: "粉晶",
    crystalTypeId: 2,
    categoryId: 2, // 手链
    popularity: 88,
    description: "精选天然粉晶，雕刻成爱心形状，搭配925银珠，象征爱与美丽。",
    energyDescription: "粉晶是爱的石头，能够打开心轮，促进自爱和人际关系的和谐。它能帮助疗愈情感创伤，吸引爱情，增强同理心。",
    scienceExplanation: "粉晶是石英家族的一员，其粉红色来源于微量的锰和钛。晶体结构与普通石英相同，硬度为7。",
    material: '925纯银、天然粉晶（10mm爱心形状）',
    size: '手链周长18cm，弹力绳设计适合多种手腕尺寸',
    weight: '约12g',
    suitableFor: '日常佩戴、情感疗愈、吸引爱情、增强自信',
    wearingAdvice: '粉晶手链佩戴在左手能更好地接收宇宙能量，右手则更适合表达和给予能量。',
    careInstructions: '避免长时间暴露在阳光下，可能导致粉晶颜色褪淡。定期用月光净化能量。',
    origin: '马达加斯加',
    certification: '附赠水晶能量证书和爱情吸引力冥想指南',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/rose_quartz_bracelet_on_white_background_82760464.webp",
      process.env.PUBLIC_URL + "/assets/images/products/elegant_rose_quartz_bracelet_on_white_background_c0604e42.webp",
      process.env.PUBLIC_URL + "/assets/images/products/raw_rose_quartz_macro_view_a4d000d1.webp"
    ]
  },
  /**
   * 黄水晶系列产品 - 耳环
   * 黄水晶代表财富与丰盛，能激活太阳神经丛轮，增强自信，吸引机遇和财富
   */
  {
    id: 3,
    name: "黄水晶太阳耳环",
    price: 259,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/citrine_earrings_on_white_background_0cb701a6.webp",
    crystalType: "黄水晶",
    crystalTypeId: 3,
    categoryId: 3, // 耳环
    popularity: 82,
    description: "明亮的黄水晶切割成太阳形状，925银镶嵌，彰显活力与阳光气息。",
    energyDescription: "黄水晶与太阳能量相连，能够激活太阳神经丛脉轮，带来丰盛、自信和创造力。它是财富和成功的象征。",
    scienceExplanation: "黄水晶是石英的一种变体，其黄色来源于铁离子。许多市场上的黄水晶实际上是经过热处理的紫水晶。",
    material: '925纯银、AAA级天然黄水晶（8mm太阳切割）',
    size: '耳环直径约1.5cm，总长度2.2cm',
    weight: '每只约3.5g',
    suitableFor: '商务场合、提升自信、吸引财富、增强个人魅力',
    wearingAdvice: '黄水晶耳环最适合在早晨佩戴，能激活一整天的积极能量。搭配黄色或金色系服装效果更佳。',
    careInstructions: '使用后用软布擦拭，避免接触香水和化妆品。可在阳光下短时间充能（不超过30分钟）。',
    origin: '巴西',
    certification: '附赠水晶能量证书和丰盛吸引力冥想音频',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/citrine_earrings_on_white_background_0cb701a6.webp",
      process.env.PUBLIC_URL + "/assets/images/products/shiny_citrine_earrings_on_white_background_e2881d49.webp",
      process.env.PUBLIC_URL + "/assets/images/products/citrine_crystal_macro_shot_0ddc20cc.webp"
    ]
  },
  /**
   * 白水晶系列产品 - 戒指
   * 白水晶代表纯净与清晰，能增强能量，净化负面情绪，提升思维清晰度
   */
  {
    id: 4,
    name: "白水晶纯净戒指",
    price: 329,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_ring.webp",
    crystalType: "白水晶",
    crystalTypeId: 4,
    categoryId: 4, // 戒指
    popularity: 90,
    description: "高透明度白水晶，简约925银戒托，展现纯净与清澈的能量。",
    energyDescription: "白水晶是能量放大器，能够净化和平衡所有脉轮。它增强意念力，提高冥想效果，是最全能的水晶之一。",
    scienceExplanation: "白水晶是二氧化硅的结晶体，是地球上最丰富的矿物之一。其透明度取决于形成过程中的纯度。",
    material: '925纯银、AAA级天然白水晶（10mm圆形切割）',
    size: '戒圈可调节，适合15-19号手指',
    weight: '约6.8g',
    suitableFor: '日常佩戴、能量工作、冥想、增强意念力、净化空间',
    wearingAdvice: '白水晶戒指佩戴在右手食指可增强意志力，左手中指则有助于平衡情绪。',
    careInstructions: '白水晶容易吸收能量，建议每周在流水下冲洗或放置在月光下净化一次。',
    origin: '巴西',
    certification: '附赠水晶能量证书和能量放大冥想指南',
    clarity: '极高透明度，内部几乎无杂质',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_ring.webp",
      process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_crystal_closeup_39f78c0a.webp",
      process.env.PUBLIC_URL + "/assets/images/products/natural_clear_quartz_cluster_on_white_background_1dcdd2b2.webp"
    ]
  },
  /**
   * 黑曜石系列产品 - 吊坠
   * 黑曜石代表保护与净化，能抵御负面能量，增强根轮稳定性，促进灵性成长
   */
  {
    id: 5,
    name: "黑曜石保护吊坠",
    price: 279,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/obsidian_pendant.webp",
    crystalType: "黑曜石",
    crystalTypeId: 5,
    categoryId: 5, // 吊坠
    popularity: 85,
    description: "天然黑曜石雕刻成盾牌形状，搭配坚固皮绳，提供强大保护能量。",
    energyDescription: "黑曜石是强大的保护石，能够抵挡负面能量和精神攻击。它帮助揭示内在真相，促进灵性成长和自我认知。",
    scienceExplanation: "黑曜石是火山玻璃，由熔岩快速冷却形成。它不是真正的晶体，而是非晶质物质，主要成分是二氧化硅。",
    material: '天然黑曜石、优质真皮绳、不锈钢扣件',
    size: '吊坠尺寸3.5cm x 2.5cm，绳长可调节45-55cm',
    weight: '约15g',
    suitableFor: '保护能量场、抵挡负面能量、灵性工作者、敏感体质人群',
    wearingAdvice: '黑曜石吊坠最好贴近皮肤佩戴，能更直接地提供保护。初次佩戴可能会感到能量强烈，建议逐渐适应。',
    careInstructions: '黑曜石吸收负能量后需要定期净化，可使用海盐水浸泡或烟熏净化。',
    origin: '墨西哥',
    certification: '附赠水晶能量证书和保护能量场冥想指南',
    specialFeatures: '彩虹黑曜石，在光线下可见彩虹般的光泽',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/obsidian_pendant.webp",
      process.env.PUBLIC_URL + "/assets/images/products/obsidian_stone_closeup_with_rainbow_sheen_00551ae3.webp",
      process.env.PUBLIC_URL + "/assets/images/products/natural_black_obsidian_raw_stone_on_white_background_ec0d8bde.webp"
    ]
  },
  /**
   * 紫水晶系列产品 - 原石摆件
   * 原石保留了水晶最原始的能量形态，适合家居摆放，净化空间能量
   */
  {
    id: 6,
    name: "紫水晶原石摆件",
    price: 599,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_amethyst_crystal_cluster_on_white_background_4961656b.webp",
    crystalType: "紫水晶",
    crystalTypeId: 1,
    categoryId: 6, // 原石
    popularity: 92,
    description: "天然紫水晶簇，保留原始晶洞形态，每件都是独一无二的艺术品。",
    energyDescription: "紫水晶簇不仅能净化个人能量，还能净化整个空间。放置在家中或办公室，有助于创造平静、专注的氛围。",
    scienceExplanation: "紫水晶簇是多个紫水晶晶体在同一基质上生长形成的。每个晶体都有六边形结构，顶端形成金字塔状。",
    material: '100%天然紫水晶簇，未经任何人工处理',
    size: '尺寸约12cm x 8cm x 10cm（每件尺寸略有不同）',
    weight: '约850-950g',
    suitableFor: '家居摆件、办公室装饰、冥想空间、能量净化、提升空间频率',
    placementAdvice: '紫水晶簇最适合放置在书房、冥想角落或工作区域，有助于提升专注力和创造力。',
    careInstructions: '避免长时间暴露在强烈阳光下，可能导致颜色褪淡。定期用羽毛掸子轻轻除尘。',
    origin: '乌拉圭',
    certification: '附赠原产地证书和真品鉴定证书',
    specialFeatures: '晶体完整，颜色深浅渐变，内部可见幻影水晶结构',
    energyLevel: '极高',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/natural_amethyst_crystal_cluster_on_white_background_4961656b.webp",
      process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp",
      process.env.PUBLIC_URL + "/assets/images/products/amethyst_ring_on_white_background_52f88b78.webp"
    ]
  },
  /**
   * 粉晶系列产品 - 手串
   * 手串形式的水晶贴近皮肤，能更直接地传递能量，影响心轮和情感能量
   */
  {
    id: 7,
    name: "粉晶爱情手串",
    price: 159,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/elegant_rose_quartz_bracelet_on_white_background_c0604e42.webp",
    crystalType: "粉晶",
    crystalTypeId: 2,
    categoryId: 2, // 手链
    popularity: 86,
    description: "8mm优质粉晶圆珠，弹力线串联，佩戴舒适，散发柔和爱的能量。",
    energyDescription: "粉晶手串贴近皮肤，能够直接影响心轮能量，促进自爱和人际关系和谐。日常佩戴有助于保持情绪平衡。",
    scienceExplanation: "粉晶珠子经过精细打磨，呈现均匀的球形。表面光滑度和颜色均匀度是评判品质的重要标准。",
    material: '天然A级粉晶（8mm珠子）、高弹力透明线',
    size: '周长约17.5cm，弹力设计适合多种手腕尺寸',
    weight: '约18g',
    suitableFor: '日常佩戴、情感疗愈、吸引爱情、增强自信、平衡情绪',
    wearingAdvice: '粉晶手串最好佩戴在左手，更容易接收宇宙的爱的能量。建议在满月时为其充能。',
    careInstructions: '避免接触化学品和香水，不建议长时间浸泡在水中。可用柔软的布轻轻擦拭表面。',
    origin: '巴西',
    certification: '附赠水晶能量证书',
    beadCount: '21颗（传统冥想数量）',
    transparency: '半透明至不透明',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/elegant_rose_quartz_bracelet_on_white_background_c0604e42.webp",
      process.env.PUBLIC_URL + "/assets/images/products/rose_quartz_bracelet_on_white_background_82760464.webp",
      process.env.PUBLIC_URL + "/assets/images/products/natural_rose_quartz_raw_stone_on_white_background_5c4f59b6.webp"
    ]
  },
  /**
   * 黄水晶系列产品 - 财富塔
   * 塔形水晶能聚集和向上引导能量，适合办公室或财位摆放，吸引财富能量
   */
  {
    id: 8,
    name: "黄水晶财富塔",
    price: 399,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_citrine_crystal_piece_on_white_background_2aa1081e.webp",
    crystalType: "黄水晶",
    crystalTypeId: 3,
    categoryId: 6, // 原石
    popularity: 89,
    description: "精心打磨的黄水晶塔，高约15cm，能量集中，适合办公室或财位摆放。",
    energyDescription: "黄水晶塔形状有助于能量向上流动和扩散。它能激活财富能量，提升工作效率和创造力，吸引机遇。",
    scienceExplanation: "水晶塔的形状使能量从底部汇集并从顶部释放。黄水晶塔通常由整块水晶雕刻而成，保留了晶体的能量结构。",
    material: '天然AAA级黄水晶，手工雕刻打磨',
    size: '高约15cm，底部直径约5cm',
    weight: '约450g',
    suitableFor: '办公室摆件、财位摆放、提升事业运、吸引财富、增强自信',
    placementAdvice: '黄水晶塔最适合放置在办公桌的左上角（财位）或工作区域，能激活财富能量。',
    careInstructions: '定期用柔软的布擦拭，可在阳光下短时间充能（不超过30分钟）。',
    origin: '巴西',
    certification: '附赠原产地证书和真品鉴定证书',
    specialFeatures: '内部可见自然生长纹理，顶部完美六边形结构',
    color: '金黄色至琥珀色，透明度高',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/natural_citrine_crystal_piece_on_white_background_2aa1081e.webp",
      process.env.PUBLIC_URL + "/assets/images/products/citrine_crystal_macro_shot_0ddc20cc.webp",
      process.env.PUBLIC_URL + "/assets/images/products/citrine_bracelet_on_white_background_66b76e04.webp"
    ]
  },
  /**
   * 白水晶系列产品 - 冥想球
   * 球形水晶能均匀向四周散发能量，适合冥想和占卜，增强直觉和精神洞察力
   */
  {
    id: 9,
    name: "白水晶冥想球",
    price: 289,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_clear_quartz_cluster_on_white_background_1dcdd2b2.webp",
    crystalType: "白水晶",
    crystalTypeId: 4,
    categoryId: 6, // 原石
    popularity: 84,
    description: "完美球形白水晶，直径约8cm，透明度高，适合冥想和能量工作。",
    energyDescription: "白水晶球能均匀地向四周散发能量，是冥想和占卜的理想工具。它能扩大思想能量，增强直觉和精神洞察力。",
    scienceExplanation: "水晶球的制作需要高质量的原材料和精细的工艺。完美的球体需要经过多次打磨和抛光，确保无气泡和裂纹。",
    material: '天然AAA级白水晶，光学级透明度',
    size: '直径约8cm',
    weight: '约680g',
    suitableFor: '冥想、占卜、能量工作、灵视训练、空间能量平衡',
    usageAdvice: '使用前建议净化水晶球，可在满月下放置一晚。冥想时，将水晶球放在双手之间或面前30cm处。',
    careInstructions: '避免长时间暴露在阳光下，可能导致火灾风险。使用专用的水晶球支架存放，避免划伤。',
    origin: '巴西',
    certification: '附赠真品鉴定证书和冥想指南',
    clarity: '极高透明度，内部几乎无杂质',
    specialFeatures: '内部可见彩虹折射，无明显气泡或裂纹',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/natural_clear_quartz_cluster_on_white_background_1dcdd2b2.webp",
      process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_crystal_closeup_39f78c0a.webp",
      process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_pendant_on_white_background_48684598.webp"
    ]
  },
  /**
   * 黑曜石系列产品 - 镜面
   * 镜面黑曜石传统用于占卜和自我反思，能反映内在真相，帮助面对阴影面
   */
  {
    id: 10,
    name: "黑曜石镜面",
    price: 499,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/obsidian_stone_closeup_with_rainbow_sheen_00551ae3.webp",
    crystalType: "黑曜石",
    crystalTypeId: 5,
    categoryId: 6, // 原石
    popularity: 87,
    description: "高抛光黑曜石圆盘，一面光滑如镜，一面保留自然纹理，直径约12cm。",
    energyDescription: "黑曜石镜面传统上用于占卜和自我反思。它能反映内在真相，帮助面对阴影面，是强大的灵性工具。",
    scienceExplanation: "黑曜石因其玻璃质地可以被抛光至镜面效果。古代文明如玛雅和阿兹特克人使用黑曜石镜面进行仪式和占卜。",
    material: '天然彩虹黑曜石，手工抛光',
    size: '直径约12cm，厚度约1.5cm',
    weight: '约550g',
    suitableFor: '占卜、灵视工作、阴影面工作、保护仪式、冥想',
    usageAdvice: '使用前建议净化黑曜石镜面，可用鼠尾草熏烟或月光净化。初次使用可能感到能量强烈，建议逐渐适应。',
    careInstructions: '避免划伤镜面，使用专用的软布擦拭。定期用海盐水净化吸收的负能量。',
    origin: '墨西哥',
    certification: '附赠真品鉴定证书和占卜指南',
    specialFeatures: '彩虹黑曜石，在光线下可见彩虹般的光泽',
    historicalSignificance: '基于古代玛雅和阿兹特克文明的神圣工具设计',
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/obsidian_stone_closeup_with_rainbow_sheen_00551ae3.webp",
      process.env.PUBLIC_URL + "/assets/images/products/natural_black_obsidian_raw_stone_on_white_background_ec0d8bde.webp",
      process.env.PUBLIC_URL + "/assets/images/products/black_obsidian_bracelet_on_white_background_db702a06.webp"
    ]
  },
  /**
   * 混合水晶系列产品 - 脉轮套装
   * 七种对应脉轮的水晶组合，用于平衡全身能量中心，适合冥想和能量疗愈
   */
  {
    id: 11,
    name: "七脉轮平衡套装",
    price: 799,
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp",
    crystalType: "混合水晶",
    crystalTypeId: 6,
    categoryId: 7, // 套装
    popularity: 94,
    description: "七种对应脉轮的水晶组合，包括紫水晶、青金石、蓝玉髓、绿aventurine、黄水晶、橙玉髓和红玉髓。",
    energyDescription: "七脉轮套装可以平衡全身能量中心，从根脉轮到顶轮。适合冥想、能量疗愈和脉轮平衡工作。",
    scienceExplanation: "每种水晶都有独特的矿物成分和晶体结构，产生不同的振动频率。科学研究表明，不同颜色的光波对人体有不同的影响。",
    material: '天然A级水晶：紫水晶、青金石、蓝玉髓、绿aventurine、黄水晶、橙玉髓、红玉髓',
    size: '每块水晶约3-4cm，配套天然亚麻收纳袋',
    weight: '总重量约350g',
    suitableFor: '脉轮平衡、能量疗愈、冥想练习、瑜伽练习、灵性工作',
    usageAdvice: '可以将水晶直接放在对应的脉轮位置，或在冥想时手持对应脉轮的水晶。建议每周进行一次完整的脉轮平衡练习。',
    careInstructions: '不同水晶需要不同的净化方法，套装附带详细的净化和充能指南。',
    origin: '多国原产（巴西、印度、非洲等）',
    certification: '附赠水晶能量证书和脉轮平衡指南手册',
    specialFeatures: '每块水晶都经过能量调谐，以最大化脉轮平衡效果',
    chakraCorrespondence: {
      crown: '紫水晶（顶轮）',
      thirdEye: '青金石（眉心轮）',
      throat: '蓝玉髓（喉轮）',
      heart: '绿aventurine（心轮）',
      solarPlexus: '黄水晶（太阳神经丛轮）',
      sacral: '橙玉髓（脐轮）',
      root: '红玉髓（根轮）'
    },
    images: [
      process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp",
      process.env.PUBLIC_URL + "/assets/images/products/raw_rose_quartz_macro_view_a4d000d1.webp",
      process.env.PUBLIC_URL + "/assets/images/products/citrine_crystal_macro_shot_0ddc20cc.webp"
    ]
  },
  /**
   * 月光石系列产品 - 戒指
   * 月光石与月亮能量相连，增强女性力量、直觉和创造力，平衡情绪
   */
  {
    id: 12,
    name: '月光石女神戒指',
    price: 349,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/moonstone_ring.webp',
    crystalType: '月光石',
    crystalTypeId: 6,
    categoryId: 4, // 戒指
    popularity: 89,
    description: '这款月光石女神戒指采用天然月光石制作，月光石与月亮能量相连，增强女性力量、直觉和创造力。它平衡情绪，促进和谐与内在成长。',
    energyDescription: '月光石与月亮能量相连，增强女性力量、直觉和创造力。它平衡情绪，促进和谐与内在成长，增强梦境意识和灵性洞察力。',
    scienceExplanation: '月光石是长石家族的一员，其特殊的光泽（称为光彩效应）是由内部结构散射光线造成的。它的晶体结构能够影响人体的电磁场和能量流动。',
    material: '925纯银、AAA级天然月光石（10mm椭圆形切割）',
    size: '戒圈可调节，适合14-18号手指',
    weight: '约7.2g',
    suitableFor: '日常佩戴、冥想、梦境工作、女性能量平衡、直觉增强',
    wearingAdvice: '月光石戒指最适合在满月期间佩戴，能增强其能量。建议佩戴在左手中指或无名指，与心轮能量相连。',
    careInstructions: '月光石较为柔软，避免碰撞和刮擦。定期在月光下净化和充能，避免阳光长时间直射。',
    origin: '斯里兰卡',
    certification: '附赠水晶能量证书和月亮能量冥想指南',
    specialFeatures: '高品质蓝光效应，在不同角度呈现蓝色光泽',
    moonPhaseEffect: '能量在满月期间达到最强，新月期间较弱',
    images: [
      process.env.PUBLIC_URL + '/assets/images/products/moonstone_ring.webp',
      process.env.PUBLIC_URL + '/assets/images/products/clear_quartz_pendant_on_white_background_48684598.webp',
      process.env.PUBLIC_URL + '/assets/images/products/clear_quartz_crystal_closeup_39f78c0a.webp'
    ]
  }
];

/**
 * 导出商品数据数组
 * 此数组将被导入到其他组件中使用，如产品列表页、产品详情页、购物车等
 * 可以通过id、crystalTypeId或categoryId进行筛选和分类展示
 */
export { products };
